
import VideoRemove from "../../../assets/outline/VideoRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VideoRemoveIcon({ className, dataTestid = "VideoRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VideoRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
